import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, customShadows, spacing, breakpoints }) => ({
    root: {
      [breakpoints.up('lg')]: {
        height: 80,
        paddingInline: spacing(2)
      },
      border: '1px solid #EDEDED',
      boxSizing: 'border-box',
      borderRadius: 2,
      backgroundColor: palette.grey.shade[5]
    },
    divider: {
      height: 54,
      marginInline: spacing(1)
    },
    tabs: {
      '&.MuiTabs-flexContainer': {
        justifyContent: 'stretch'
      },
      [breakpoints.down('lg')]: {
        '& .MuiTab-root:not(:first-child)::before': {
          content: '""',
          display: ({ selected }) => (selected === false ? 'block' : 'none'),
          position: 'absolute',
          left: 0,
          height: '67%',
          borderLeft: '1px solid #BDBDBD'
        }
      }
    },
    indicator: {
      background: 'none'
    },
    panel: {
      margin: 'auto',
      width: '100%',
      padding: spacing(1),
      backgroundColor: palette.white.off,
      [breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch'
      }
    },
    clear: {
      [breakpoints.down('lg')]: {
        marginLeft: spacing(4),
        justifyContent: 'flex-start'
      },
      fontWeight: 700,
      color: palette.grey.shade[100],
      '&:disabled': {
        color: palette.grey.shade[50]
      }
    },
    clearText: {
      fontWeight: 'inherit'
    },
    searchItem: {
      marginLeft: 'auto'
    },
    icon: {
      display: 'block'
    }
  })
)
